import React, {useRef, useState} from "react";
import emailjs from '@emailjs/browser'
import "./Contact.css";
import { themeContext } from "../../Context";
import { useContext } from "react";


export const Contact = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const form = useRef();
  const [done, setDone] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_yp13c8c",
        "template_frtv4gl",
        form.current,
        "-U-2asxYF4BzHg1cf"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div id="Contact" className="contact-form" onSubmit={sendEmail}>
      <div className="w-left">
        <br />
        <br />
        <div className="awesome">
          <span style={{ color: darkMode ? "white" : "" }}>Get in touch</span>
          <span>Contact me</span>
        
        </div>
      </div>

      <div className="c-right">
        <form ref={form}>
          <input
            type="text"
            name="user_name"
            className="user"
            placeholder="Name"
          />
          <input
            type="text"
            name="user_email"
            className="user"
            placeholder="Email"
          />
          <textarea
            name="message"
            className="user"
            placeholder="Message"
            id=""
            cols="30"
            rows="10"
          ></textarea>
          <input type="submit" value="send" className="button" />
          <span>{done && "Thanks for contact me!"}</span>
        </form>
      </div>
    </div>
  );
};
